import {combineReducers} from "redux";
import {dataReducer} from "./dataReducer";
import {statusConnections} from "./statusConnectionsReducer";

export  const rootReducer = combineReducers({
    statData: dataReducer,
    statusConnections: statusConnections
})